export const urlFacebook = "https://www.facebook.com/niwynatury";
export const urlInsta = "https://www.instagram.com/niwy_natury_pracownia_zdrowia/";